import { render, staticRenderFns } from "./parent_page.vue?vue&type=template&id=ca517c1e&scoped=true&"
import script from "./parent_page.vue?vue&type=script&lang=js&"
export * from "./parent_page.vue?vue&type=script&lang=js&"
import style0 from "./parent_page.vue?vue&type=style&index=0&id=ca517c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca517c1e",
  null
  
)

export default component.exports